
<div *ngIf="!_autoMl.isAutoMl" class="scad-drag-sidemenu" >
  <div class="scad-title__semi-bold mb-4">Destination</div>
  <div *ngIf="!_flowBuilder.isPublishToIfp">
    <div class="scad-title__sm-label">
      You can choose to unload your data into a connector or export the dataset
      directly.
    </div>
    <!-- <div class="scad-input pt-4">
      <input type="text" class="scad-input-half" placeholder="Publish Data" [(ngModel)]="_flowBuilder.saveName"/>
    </div> -->
  </div>


  <ng-container *ngIf="!_flowBuilder.isPublishToIfp;else publishToIfp">
  <div class="pt-3">
    <div class="line"></div>

    <div class="pt-3">
      <div class="scad-input scad-input--search-right-border">
        <span class="scad-icon scad-icon-search scad-input__search-icon">
          <img src="assets//images/svg/Search.svg" alt="" />
        </span>
        <input type="text" [(ngModel)]="searchTerm" class="scad-input--search-right-border" placeholder="Search.."/>
      </div>
    </div>

    <div class="pt-3 scad-scroll-box">
      <!-- searchFilterPipe -->
        <div *ngFor="let item of destinationType|searchFilterPipe:searchTerm:'name'" class="scad-destination-card mt-3" (click)="item.click()">
          <div class="d-flex justify-content-end align-items-center" >
            <div class="scad-destination-card__logo d-flex"> <img [src]="item.img" alt="" /> </div>
            <div  class="scad-destination-card__label ps-4">{{item.name}}</div>
          </div>
          <app-circle-loader *ngIf="item.isLoad"></app-circle-loader>
          <div>
            <div class="scad-destination-card__info">
              <img src="assets//images/svg/info.svg" alt="" />
            </div>
          </div>
        </div>

        <!-- <div class="scad-destination-card mt-3">
          <div class="d-flex justify-content-end align-items-center">
            <div class="scad-destination-card__logo d-flex"> <img src="assets//images/svg/oracle.svg" alt="" /> </div>
            <div  class="scad-destination-card__label ps-4">GDP Oracle DB</div>
          </div>
          <div>
            <div class="scad-destination-card__info">
              <img src="assets//images/svg/info.svg" alt="" />
            </div>
          </div>
        </div> -->

    </div>

    <div class="mt-3">
      <button class="scad-btn scad-btn--secondary download-btn">
        <span>Download Output</span> <span class="ps-2 d-flex">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66669 11.0742L9.72224 14.125L12.7778 11.0742" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.72229 2.6665V13.3624" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33331 17.3335H15.5555" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
      </button>

      <div class="d-flex align-items-center mt-3">
        <input id="name" type="checkbox">
        <label for="name" class="ps-2 d-flex align-items-center">Automatically save output <span class="ps-2"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.5 5L7.44996 10L11.3571 5" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </span>
        </label>
      </div>

    </div>


  </div>
  </ng-container>

  <ng-template #publishToIfp>
  <div class="pt-3">
    <!-- (click)="_flowBuilder.isPublishToIfp =false" -->
    <div  class="pb-3 d-flex align-items-center scad-title__sm-thin-blue"> <span class="pe-2"> <img src="assets/images/svg/left-arrow.svg" alt=""> </span> Back to Destination Settings </div>
    <div class="pb-3 scad-title__sm-thin-gray">Select Visualization Type</div>

    <div class="row pb-3">
      <div class="col-6" *ngFor="let item of visualizeTypes;">
        <div class="d-flex align-items-center mb-3">
          <div class="scad-radio">
            <label class="ps-2 scad-title__sm-thin-gray2"><input type="radio" class="input-radio blue" name="chart" [value]="item" [(ngModel)]="_flowBuilder.visualizeType"> {{item}} </label>
          </div>
        </div>
      </div>
    </div>

  <div class="pb-3">
    <div class="pb-2 scad-title__sm-thin-gray"> Visualization Title</div>
    <div class="scad-input" >
      <input class="sh-input-text" type="text" *ngIf="_flowBuilder.visualizeType == 'KPI Card'" placeholder="Title Here.." [disabled]="publishToIFP" [(ngModel)]="_flowBuilder.visualizeTitle">
      <input type="text" class="sh-input-text" *ngIf="_flowBuilder.visualizeType !== 'KPI Card'" placeholder="Title Here..">
    </div>
  </div>

  <div class="pb-3">
    <div class="pb-2 scad-title__sm-thin-gray"> Visualization Description</div>
    <div class="scad-input">
      <textarea name="" class="sh-input-text" id="" cols="100%" rows="4" *ngIf="_flowBuilder.visualizeType == 'KPI Card'" placeholder="Description Here.." [disabled]="publishToIFP"  [(ngModel)]="_flowBuilder.visualizeDescription"></textarea>
      <textarea name="" class="sh-input-text" id="" cols="100%" rows="4" *ngIf="_flowBuilder.visualizeType !== 'KPI Card'" placeholder="Description Here.."></textarea>
    </div>
  </div>

  <div class="pb-2">
    <div class="d-flex justify-content-between align-items-center">
      <div class="pb-2 scad-title__sm-thin-gray2">Add to My Apps </div>
      <div class="pb-2 scad-title__sm-thin-gray"><div  class="scad-toggle"> <input [disabled]="publishToIFP" type="checkbox" id="switch" /><label for="switch">Toggle</label></div> </div>
    </div>
  </div>

  <!-- <div class="pb-3">
    <div class="d-flex justify-content-between align-items-center">
      <div class="pb-2 scad-title__sm-thin-gray2">Add to Visualisation Board</div>
      <div class="pb-2 scad-title__sm-thin-gray"><div  class="scad-toggle"> <input type="checkbox" [disabled]="publishToIFP" id="switch2" [(ngModel)]="isVisualizationBoard" /><label for="switch2">Toggle</label></div> </div>
    </div>
  </div> -->


  <div class="pb-3" *ngIf="isVisualizationBoard">
    <div class="pb-2 scad-title__sm-thin-gray"> Destination Board</div>
    <div class="scad-input">
      <ng-select class="scad-input-dropdown ng-select-default" [disabled]="publishToIFP" [items]="destination" bindLabel="name" placeholder="Select Destination" [(ngModel)]="selectedDestination">
    </ng-select>
    </div>
  </div>

  <div  *ngIf="isVisualizationBoard" class="pb-3 d-flex align-items-center scad-title__sm-thin-blue"> Create New Visualisation Board  <span class="d-flex ps-2"> <img src="../../../../../assets/images/svg/plus-icon2.svg" alt=""> </span>  </div>
  <div class="line"></div>

  <div class="pb-4 pt-4">
    <div class="pb-2 scad-title__sm-thin-gray"> Chart Type <span style="color: red;">*</span></div>
    <div class="scad-input">
      <ng-select class="scad-input-dropdown ng-select-default" [disabled]="publishToIFP"  [items]="chartType" bindLabel="name" placeholder="Select Type" [(ngModel)]="_flowBuilder.selectedType">
    </ng-select>

    </div>
  </div>

  <div class="pb-3">
    <div class="pb-2 scad-title__sm-thin-gray d-flex"> Values (X-axis) <span style="color: red;">*</span> <img class="ps-2" src="../../../../../assets/images/svg/information-circle-outline.svg" alt=""> <span></span></div>
    <div class="scad-input">
      <ng-select class="scad-input-dropdown ng-select-default" [items]="_flowBuilder.selectedAxisValues" [disabled]="publishToIFP" bindLabel="name" placeholder="Select X-axis" [(ngModel)]="_flowBuilder.selectedXAxis" (change)="getCardCharge()">
    </ng-select>

    </div>
  </div><div class="pb-3">
    <div class="pb-2 scad-title__sm-thin-gray d-flex"> Observation data (Y-axis) <span style="color: red;">*</span><img class="ps-2" src="../../../../../assets/images/svg/information-circle-outline.svg" alt=""> <span></span></div>
    <div class="scad-input">
      <ng-select class="scad-input-dropdown ng-select-default" [disabled]="publishToIFP" [items]="_flowBuilder.selectedAxisValues" bindLabel="name"
        placeholder="Select Y-axis" [(ngModel)]="_flowBuilder.selectedYAxis" (change)="getCardCharge()">
      </ng-select>
    </div>
  </div>

  <div class="preview" (click)="saveVisualisation()">
    <p>Preview</p>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path d="M10.5 13.125C11.9497 13.125 13.125 11.9497 13.125 10.5C13.125 9.05025 11.9497 7.875 10.5 7.875C9.05025 7.875 7.875 9.05025 7.875 10.5C7.875 11.9497 9.05025 13.125 10.5 13.125Z" fill="#1847DF"/>
      <path d="M20.132 9.78633C19.0467 8.10797 17.6386 6.68227 16.0603 5.66303C14.3143 4.53428 12.3866 3.9375 10.4859 3.9375C8.74191 3.9375 7.02705 4.43584 5.38888 5.41857C3.71832 6.42059 2.20484 7.88443 0.890291 9.7691C0.74189 9.9821 0.66016 10.2344 0.655486 10.494C0.650812 10.7535 0.723405 11.0086 0.864041 11.2268C1.94726 12.922 3.34138 14.3497 4.89506 15.355C6.64437 16.4883 8.52699 17.0625 10.4859 17.0625C12.4017 17.0625 14.3336 16.4706 16.0722 15.3513C17.6497 14.3354 19.0549 12.9043 20.1361 11.212C20.2718 10.9989 20.3436 10.7513 20.3429 10.4986C20.3422 10.2459 20.269 9.99867 20.132 9.78633V9.78633ZM10.4998 14.4375C9.72108 14.4375 8.9598 14.2066 8.31228 13.7739C7.66476 13.3413 7.16009 12.7263 6.86207 12.0068C6.56405 11.2873 6.48607 10.4956 6.638 9.73183C6.78993 8.96803 7.16494 8.26644 7.71561 7.71577C8.26628 7.1651 8.96787 6.79009 9.73167 6.63816C10.4955 6.48623 11.2872 6.5642 12.0067 6.86222C12.7261 7.16024 13.3411 7.66492 13.7738 8.31244C14.2064 8.95996 14.4373 9.72124 14.4373 10.5C14.4361 11.5439 14.0209 12.5447 13.2828 13.2829C12.5446 14.0211 11.5438 14.4363 10.4998 14.4375V14.4375Z" fill="#1847DF"/>
    </svg>
  </div>

  <div class="scad-form mt-3">
    <button class="scad-btn scad-btn--secondary download-btn" (click)="publishToIFP=true"><span>Publish to IFP</span></button>
    <button class="scad-btn scad-btn--secondary download-btn" ><span>Save Draft</span></button>
  </div>



  </div>
  </ng-template>
</div>
<div *ngIf="_autoMl.isAutoMl">
  <app-auto-ml></app-auto-ml>
</div>
